export default __webpack_public_path__ + "static/font-76b528e083f03965bf295253d469e28d.woff";